import {AXIOSunsecure} from "@/common/http-common";
import {SERVICE_IDENTIY} from "@/properties/micro-service";
import {mapActions} from "vuex";

export const forgotPasswordMixin = {

  data() {
    return {
      changePassword: {},
      isLoading: false,
      globalErrors: [],
      message: null
    }
  },
  methods: {
    ...mapActions(['pushGlobalError', 'setMessage', 'setGlobalMessages']),
    clearMessages() {
      this.globalErrors.splice(0);
      this.message = '';
    },
    isRequired(attrib) {
      return this.isLoading && !this.$v.changePassword[attrib].required;
    },
    postUnsecuredData(url, postData, fn) {

      this.isLoading = true;
      AXIOSunsecure().post(url, postData)
        .then(response => {
          this.isLoading = false;
          //This should be called last after doing all the above
          //so that we can override the message.
          fn(response.data);

        })
        .catch(e => {
          this.catchError(e);
        })
    },

    catchError(error) {
      this.isLoading = false;
      if (error.response) {
        if (error.response.data && error.response.data.error) {
          this.pushGlobalError(error.response.data.error);
        } else {
          this.setGlobalMessages(error.response.data);
        }
      } else if (error.request) {
        this.pushGlobalError('Network Error');
      } else {
        this.pushGlobalError(error.message);
      }
    },
  }

}
